// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";


/*내용*/
.contents{
    width: calc(100% - 96px);
    background: #F8F9FA;
    height: 797px;
    padding: 12px 27px;
    box-sizing: border-box;
    display: flex;
}
.contents > div{margin-right: 15px;}
.contents > div:last-child{margin-right: 0;}
.contents > div h2{
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.96px;
    margin-bottom: 22px;
}
/*고객리스트*/
.list > div{
    width: 294px;
    height: 217px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    margin-bottom: 25px;
    padding: 8px 15px;
    box-sizing: border-box;
}
.list > div.req_list{height: 700px;}

.list > div:last-child{margin-bottom: 0;}
.list > div .circle{
    display: inline-block;
    margin-right: 7px;
    width: 16px;
    height: 16px;
    border-radius: 8px;
}
.list .req_list .circle{background: #D3F05D;}
.list .answ_list .circle{background: #6590FD;}
.list .resv_list .circle{background: #51D7DF;}
.list .complete_list .circle{background: #65FDCF;}

.list > div .tit{
    font-size: 20px;
    font-weight: 500;
    letter-spacing: -0.8px;
}
.list > div ul{width: 100%; height: 154px; overflow-y: scroll; margin: 8px auto 0;}
.list > div.req_list ul{width: 100%; height: 630px; overflow-y: scroll; margin: 8px auto 0;}

/** 세로스크롤 제거 */
/* Chrome, Safari, newer versions of Opera */
.list > div ul::-webkit-scrollbar {
    display: none;
}

/* Firefox */
.list > div ul {
    scrollbar-width: none;
}

/* IE 10+ */
.list > div ul {
    -ms-overflow-style: none;
}
/** 세로스크롤 제거 끝 */
  
/*list item*/
.list > div .item{
    width: 100%;
    height: 44px;
    border-radius: 5px;
    border: 1px solid #E0E0E0;
    margin-bottom: 8px;
    box-sizing: border-box;
}
.list > div .item a{
    width: 100%; height: 44px;display: flex;
    align-items: center;
    padding: 0 15px 0 11px;
    box-sizing: border-box;
    position: relative;
}
.list > div .item:last-child{margin-bottom: 0;}
.list > div .item svg{margin-right: 6px;}
.list > div .item span{margin-right: 16px;vertical-align:super;font-size: 15px;}
.list > div .item .time{margin-left: auto; margin-right: 0;text-align: right;}

/*list item active, hover*/
.list > div .item.on{background: #51D7DF;border: none;}
.list > div .item.on path{fill: #fff;}
.list > div .item.on span{color: #fff;}

.list > div .item:hover{background: #51D7DF;border: none;}
.list > div .item:hover path{fill: #fff;}
.list > div .item:hover span{color: #fff;}


/*캘린더*/
.calendar_box{width: calc(100% - 309px);}
.calendar_box #calendar-container{
    width: 100%;
    height: 701px;
    background: #fff;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    border-radius: 20px;
    padding: 25px 20px;
    box-sizing: border-box;
}
.fc-day-today{background: #F0FFFE !important;}
.fc .fc-toolbar-title {
    font-size: 1.45em !important;
    margin: 0;
}
.fc .fc-button-primary{
    background: #51D7DF !important; border: none !important;
}
.fc-daygrid-event-dot{
    border: 4px solid #51D7DF !important;
}
.fc .fc-daygrid-day-top {
    flex-direction: row !important;
}
/*일요일 날짜 빨간색*/
.fc-day-sun a {
  color: #F89797;
  text-decoration: none;
}

/*요청정보*/
.info{display: none;}

.req_box{
    width: 320px;
    height: 660px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    margin-bottom: 25px;
    padding: 20px 22px 20px 20px;display: flex;
    flex-direction: column;
}

.basic_info{display: flex; margin-bottom: 15px; flex-shrink: 0;}
.basic_info span{font-size: 18px;}
.basic_info > div{display: inline-block; width: 100%;}
.basic_info .tit{
    color: #51D7DF;
    font-size: 16px;
    font-weight: 700;
    line-height: 150%; /* 24px */
    letter-spacing: -0.64px;
}
.basic_info > div:last-child{text-align: right;}
.line{width: 100%; height: 1px; background: #EBEBEB; margin: 12px 0 12px; }
/*이미지*/
.img_list{width: 100%; overflow: hidden;}
.img_list ul{width: 284px;display: flex;}
.img_list ul li{width: 80px; height: 80px; border-radius: 10px; overflow: hidden; background: #ccc; margin-right: 20px;}
.img_list ul li:last-child{margin-right: 0;}
.img_list ul li img{width: inherit;}

.req_box .detail_info {
    flex-grow:1;
    overflow-y:auto;
    position: relative;
}

/*상세설명*/
.detail{
    width: 100%; height: 154px;border-radius: 20px; border: 1px solid #EBEBEB;
    padding: 13px 6px 10px 13px; box-sizing: border-box;overflow-y: scroll;
    margin-bottom: 30px;
}
.detail .tit{
    display: block;
    color: #51D7DF;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.64px;
    margin-bottom: 8px;
}
/*태그*/
.tags{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 10px 0;
}
.tag{
    border-radius: 20px;
    border: 1px solid #C4C4C4;
    color: #8B8686;
    font-size: 13px;
    margin-left:3px;
    margin-right:3px;
    padding: 2px 9px;
    margin-top: 5px;
}
/*답변*/
.answer_box{position: relative; height:240px;}
.answer{
    width: 100%; border-radius: 20px; border: 1px solid #EBEBEB;
    padding: 9px 6px 10px 13px; box-sizing: border-box;overflow: auto;
    scrollbar-width: none; /* Firefox를 위해 */
    -ms-overflow-style: none; /* IE와 Edge를 위해 */
}
.answer::-webkit-scrollbar { display: none; }

.answer .top{display: flex;justify-content: space-between; align-content: center;}
.answer .tit{
    color: #51D7DF;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.64px;
    margin-bottom: 8px;
}

.answer textarea{
    width:100%;
    margin-top: 6px;
    border: none;
    resize:none;
}
.info .send_btn{
    width: 121px;
    padding: 11px 14px;
    text-align: center;
    line-height: 14px;
    border-radius: 21px;
    border: 1px solid #51D7DF;
    background: #51D7DF;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.72px;
    margin-top: 10px;
    position: absolute; right: 0; bottom: 0;
}

.info .send_btn:disabled {
    background:#174143;
    border: 1px solid #174143;
    color: #8B8686;
}`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA,gBAAgB;;;AAGhB,KAAK;AACL;IACI,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAEV,sBAAsB;IAG9B,aAAa;AACjB;AACA,gBAAgB,kBAAkB,CAAC;AACnC,2BAA2B,eAAe,CAAC;AAC3C;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA,QAAQ;AACR;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,sDAAsD;IAC9D,mBAAmB;IACnB,iBAAiB;IAET,sBAAsB;AAClC;AACA,qBAAqB,aAAa,CAAC;;AAEnC,uBAAuB,gBAAgB,CAAC;AACxC;IACI,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA,wBAAwB,mBAAmB,CAAC;AAC5C,yBAAyB,mBAAmB,CAAC;AAC7C,yBAAyB,mBAAmB,CAAC;AAC7C,6BAA6B,mBAAmB,CAAC;;AAEjD;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA,eAAe,WAAW,EAAE,aAAa,EAAE,kBAAkB,EAAE,kBAAkB,CAAC;AAClF,wBAAwB,WAAW,EAAE,aAAa,EAAE,kBAAkB,EAAE,kBAAkB,CAAC;;AAE3F,cAAc;AACd,4CAA4C;AAC5C;IACI,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI,qBAAqB;AACzB;;AAEA,WAAW;AACX;IACI,wBAAwB;AAC5B;AACA,gBAAgB;;AAEhB,YAAY;AACZ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAEV,sBAAsB;AAClC;AACA;IACI,WAAW,EAAE,YAAY,CAA2C,aAAa;IAGzE,mBAAmB;IAC3B,sBAAsB;IAEd,sBAAsB;IAC9B,kBAAkB;AACtB;AACA,6BAA6B,gBAAgB,CAAC;AAC9C,sBAAsB,iBAAiB,CAAC;AACxC,uBAAuB,kBAAkB,CAAC,oBAAoB,CAAC,eAAe,CAAC;AAC/E,wBAAwB,iBAAiB,EAAE,eAAe,CAAC,iBAAiB,CAAC;;AAE7E,0BAA0B;AAC1B,qBAAqB,mBAAmB,CAAC,YAAY,CAAC;AACtD,0BAA0B,UAAU,CAAC;AACrC,0BAA0B,WAAW,CAAC;;AAEtC,wBAAwB,mBAAmB,CAAC,YAAY,CAAC;AACzD,6BAA6B,UAAU,CAAC;AACxC,6BAA6B,WAAW,CAAC;;;AAGzC,MAAM;AACN,cAAc,yBAAyB,CAAC;AACxC;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAER,sDAAsD;IAC9D,mBAAmB;IACnB,kBAAkB;IAEV,sBAAsB;AAClC;AACA,cAAc,8BAA8B,CAAC;AAC7C;IACI,4BAA4B;IAC5B,SAAS;AACb;AACA;IACI,8BAA8B,EAAE,uBAAuB;AAC3D;AACA;IACI,oCAAoC;AACxC;AACA;IAIY,8BAA8B;AAC1C;AACA,aAAa;AACb;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,OAAO;AACP,MAAM,aAAa,CAAC;;AAEpB;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,sDAAsD;IAC9D,mBAAmB;IACnB,4BAA4B,CACc,aAAa;IACvD,sBAAsB;AAC1B;;AAEA,YAAsD,aAAa,EAAE,mBAAmB,EAAE,cAAc,CAAC;AACzG,iBAAiB,eAAe,CAAC;AACjC,kBAAkB,qBAAqB,EAAE,WAAW,CAAC;AACrD;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,uBAAuB;AAC3B;AACA,6BAA6B,iBAAiB,CAAC;AAC/C,MAAM,WAAW,EAAE,WAAW,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC1E,MAAM;AACN,UAAU,WAAW,EAAE,gBAAgB,CAAC;AACxC,aAAa,YAAY,CAA2C,aAAa,CAAC;AAClF,gBAAgB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,CAAC;AACvH,2BAA2B,eAAe,CAAC;AAC3C,oBAAoB,cAAc,CAAC;;AAEnC;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA,OAAO;AACP;IACI,WAAW,EAAE,aAAa,CAAC,mBAAmB,EAAE,yBAAyB;IACzE,2BAA2B,EAAkC,sBAAsB,CAAC,kBAAkB;IACtG,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;AACA,KAAK;AACL;IAGI,aAAa;IAEb,eAAe;IAGf,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA,KAAK;AACL,YAAY,kBAAkB,EAAE,YAAY,CAAC;AAC7C;IACI,WAAW,EAAE,mBAAmB,EAAE,yBAAyB;IAC3D,0BAA0B,EAAkC,sBAAsB,CAAC,cAAc;IACjG,qBAAqB,EAAE,gBAAgB;IACvC,wBAAwB,EAAE,iBAAiB;AAC/C;AACA,6BAA6B,aAAa,EAAE;;AAE5C,aAAuD,aAAa,CAAkD,8BAA8B,EAA8B,qBAAqB,CAAC;AACxM;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,YAAY;IACZ,WAAW;AACf;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB,EAAE,QAAQ,EAAE,SAAS;AAC3C;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":["@charset \"utf-8\";\n\n\n/*내용*/\n.contents{\n    width: calc(100% - 96px);\n    background: #F8F9FA;\n    height: 797px;\n    padding: 12px 27px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.contents > div{margin-right: 15px;}\n.contents > div:last-child{margin-right: 0;}\n.contents > div h2{\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    letter-spacing: -0.96px;\n    margin-bottom: 22px;\n}\n/*고객리스트*/\n.list > div{\n    width: 294px;\n    height: 217px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    margin-bottom: 25px;\n    padding: 8px 15px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.list > div.req_list{height: 700px;}\n\n.list > div:last-child{margin-bottom: 0;}\n.list > div .circle{\n    display: inline-block;\n    margin-right: 7px;\n    width: 16px;\n    height: 16px;\n    border-radius: 8px;\n}\n.list .req_list .circle{background: #D3F05D;}\n.list .answ_list .circle{background: #6590FD;}\n.list .resv_list .circle{background: #51D7DF;}\n.list .complete_list .circle{background: #65FDCF;}\n\n.list > div .tit{\n    font-size: 20px;\n    font-weight: 500;\n    letter-spacing: -0.8px;\n}\n.list > div ul{width: 100%; height: 154px; overflow-y: scroll; margin: 8px auto 0;}\n.list > div.req_list ul{width: 100%; height: 630px; overflow-y: scroll; margin: 8px auto 0;}\n\n/** 세로스크롤 제거 */\n/* Chrome, Safari, newer versions of Opera */\n.list > div ul::-webkit-scrollbar {\n    display: none;\n}\n\n/* Firefox */\n.list > div ul {\n    scrollbar-width: none;\n}\n\n/* IE 10+ */\n.list > div ul {\n    -ms-overflow-style: none;\n}\n/** 세로스크롤 제거 끝 */\n  \n/*list item*/\n.list > div .item{\n    width: 100%;\n    height: 44px;\n    border-radius: 5px;\n    border: 1px solid #E0E0E0;\n    margin-bottom: 8px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.list > div .item a{\n    width: 100%; height: 44px;display: -webkit-box;display: -ms-flexbox;display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0 15px 0 11px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    position: relative;\n}\n.list > div .item:last-child{margin-bottom: 0;}\n.list > div .item svg{margin-right: 6px;}\n.list > div .item span{margin-right: 16px;vertical-align:super;font-size: 15px;}\n.list > div .item .time{margin-left: auto; margin-right: 0;text-align: right;}\n\n/*list item active, hover*/\n.list > div .item.on{background: #51D7DF;border: none;}\n.list > div .item.on path{fill: #fff;}\n.list > div .item.on span{color: #fff;}\n\n.list > div .item:hover{background: #51D7DF;border: none;}\n.list > div .item:hover path{fill: #fff;}\n.list > div .item:hover span{color: #fff;}\n\n\n/*캘린더*/\n.calendar_box{width: calc(100% - 309px);}\n.calendar_box #calendar-container{\n    width: 100%;\n    height: 701px;\n    background: #fff;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    border-radius: 20px;\n    padding: 25px 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.fc-day-today{background: #F0FFFE !important;}\n.fc .fc-toolbar-title {\n    font-size: 1.45em !important;\n    margin: 0;\n}\n.fc .fc-button-primary{\n    background: #51D7DF !important; border: none !important;\n}\n.fc-daygrid-event-dot{\n    border: 4px solid #51D7DF !important;\n}\n.fc .fc-daygrid-day-top {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n            flex-direction: row !important;\n}\n/*일요일 날짜 빨간색*/\n.fc-day-sun a {\n  color: #F89797;\n  text-decoration: none;\n}\n\n/*요청정보*/\n.info{display: none;}\n\n.req_box{\n    width: 320px;\n    height: 660px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    margin-bottom: 25px;\n    padding: 20px 22px 20px 20px;\n    display: -webkit-box;display: -ms-flexbox;display: flex;\n    flex-direction: column;\n}\n\n.basic_info{display: -webkit-box;display: -ms-flexbox;display: flex; margin-bottom: 15px; flex-shrink: 0;}\n.basic_info span{font-size: 18px;}\n.basic_info > div{display: inline-block; width: 100%;}\n.basic_info .tit{\n    color: #51D7DF;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.64px;\n}\n.basic_info > div:last-child{text-align: right;}\n.line{width: 100%; height: 1px; background: #EBEBEB; margin: 12px 0 12px; }\n/*이미지*/\n.img_list{width: 100%; overflow: hidden;}\n.img_list ul{width: 284px;display: -webkit-box;display: -ms-flexbox;display: flex;}\n.img_list ul li{width: 80px; height: 80px; border-radius: 10px; overflow: hidden; background: #ccc; margin-right: 20px;}\n.img_list ul li:last-child{margin-right: 0;}\n.img_list ul li img{width: inherit;}\n\n.req_box .detail_info {\n    flex-grow:1;\n    overflow-y:auto;\n    position: relative;\n}\n\n/*상세설명*/\n.detail{\n    width: 100%; height: 154px;border-radius: 20px; border: 1px solid #EBEBEB;\n    padding: 13px 6px 10px 13px; -webkit-box-sizing: border-box; box-sizing: border-box;overflow-y: scroll;\n    margin-bottom: 30px;\n}\n.detail .tit{\n    display: block;\n    color: #51D7DF;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: -0.64px;\n    margin-bottom: 8px;\n}\n/*태그*/\n.tags{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    padding: 10px 0;\n}\n.tag{\n    border-radius: 20px;\n    border: 1px solid #C4C4C4;\n    color: #8B8686;\n    font-size: 13px;\n    margin-left:3px;\n    margin-right:3px;\n    padding: 2px 9px;\n    margin-top: 5px;\n}\n/*답변*/\n.answer_box{position: relative; height:240px;}\n.answer{\n    width: 100%; border-radius: 20px; border: 1px solid #EBEBEB;\n    padding: 9px 6px 10px 13px; -webkit-box-sizing: border-box; box-sizing: border-box;overflow: auto;\n    scrollbar-width: none; /* Firefox를 위해 */\n    -ms-overflow-style: none; /* IE와 Edge를 위해 */\n}\n.answer::-webkit-scrollbar { display: none; }\n\n.answer .top{display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-pack: justify;-ms-flex-pack: justify;justify-content: space-between; -ms-flex-line-pack: center; align-content: center;}\n.answer .tit{\n    color: #51D7DF;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: -0.64px;\n    margin-bottom: 8px;\n}\n\n.answer textarea{\n    width:100%;\n    margin-top: 6px;\n    border: none;\n    resize:none;\n}\n.info .send_btn{\n    width: 121px;\n    padding: 11px 14px;\n    text-align: center;\n    line-height: 14px;\n    border-radius: 21px;\n    border: 1px solid #51D7DF;\n    background: #51D7DF;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 700;\n    letter-spacing: -0.72px;\n    margin-top: 10px;\n    position: absolute; right: 0; bottom: 0;\n}\n\n.info .send_btn:disabled {\n    background:#174143;\n    border: 1px solid #174143;\n    color: #8B8686;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
